import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: "I used to spend my entire Sunday building meal plans and intake forms from scratch. With Nutritionist Pro I open the Nutrition Plan Builder, pick a framework, and I'm ready in minutes. I've reclaimed at least 6 hours a week – and my clients think my materials look more professional than ever.",
  author: 'Rachel Simmons',
  role: 'Registered Dietitian (RDN)',
  location: 'Columbus, OH'
}, {
  text: 'As a newly licensed nutritionist, I was terrified of my first consultations. The Client Assessment System gave me exactly the intake forms and questionnaires I needed to look and feel like a seasoned pro. Clients trust me from the very first session now.',
  author: 'Priya Nair',
  role: 'Clinical Nutritionist',
  location: 'Austin, TX'
}, {
  text: 'The Patient Education Library alone paid for this ten times over. Instead of screenshotting handouts from random PDFs, I hand my clients clean, branded guides. My follow-up adherence has jumped and people actually stick to their plans.',
  author: 'Danielle Foster',
  role: 'Sports Nutritionist',
  location: 'Denver, CO'
}, {
  text: "I run my whole practice online and the Client Progress Tracker changed everything. The check-in forms and habit trackers keep my virtual clients accountable between sessions. My retention rate is the highest it's ever been in 9 years of practice.",
  author: "Megan O'Brien",
  role: 'Functional Nutrition Professional',
  location: 'Portland, OR'
}, {
  text: 'The bonuses are ridiculous value. The Professional Forms Vault and the Social Media Content system saved me from hiring an assistant. Everything is organized in one place — no more digging through folders. This is the system I wish I had on day one.',
  author: 'Sofia Herrera',
  role: 'Dietitian & Wellness Clinic Owner',
  location: 'Miami, FL'
}];
export function Testimonials() {
  return <section className="py-8 px-4 bg-white border-y-4 border-brand-rose/20" data-id="element-168">
      <div className="max-w-4xl mx-auto" data-id="element-169">
        <div className="text-center mb-6" data-id="element-170">
          <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-brand-graphite mb-1 uppercase" data-id="element-171">
            WHAT YOUR COLLEAGUES ARE SAYING
          </h2>
          <p className="text-base font-bold text-brand-rose uppercase tracking-wide" data-id="element-172">
            Testimonials from nutrition professionals
          </p>
        </div>

        <div className="space-y-3" data-id="element-173">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-cream border-2 border-brand-rose/30 p-4 rounded-lg shadow-sm" data-id="element-174">
              <div className="flex gap-1 mb-2" data-id="element-175">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-176" />)}
              </div>
              <p className="text-brand-graphite/90 font-medium mb-3 leading-snug italic text-sm sm:text-base" data-id="element-177">
                "{t.text}"
              </p>
              <div className="border-t border-brand-rose/20 pt-3 flex items-center gap-3" data-id="element-178">
                <div className="w-10 h-10 rounded-full bg-brand-rose/20 flex items-center justify-center text-brand-rose font-extrabold text-lg border border-brand-rose/30" data-id="element-179">
                  {t.author.charAt(0)}
                </div>
                <div className="leading-tight" data-id="element-180">
                  <p className="font-bold text-brand-graphite text-sm" data-id="element-181">
                    {t.author}
                  </p>
                  <p className="text-[11px] sm:text-xs text-brand-graphite/70 font-bold uppercase tracking-wide" data-id="element-182">
                    {t.role} — {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}